import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const sedekahMuslim2588: Quote = {
  id: "sedekah-muslim-2588",
  name: "Harta Tidak Berkurang Karena Sedekah",
  emoji: "💎",
  category: "Sedekah & Kebaikan",
  description:
    "Rasulullah ﷺ bersabda: **\"Sedekah itu tidak mengurangi harta\"** — bahkan memaafkan menambah kemuliaan, dan tawadhu mengangkat derajat.",
  detail:
    "Hadits ini memuat tiga jaminan sekaligus: sedekah tidak mengurangi harta, memaafkan menambah kemuliaan, dan rendah hati mengangkat derajat. Ketiganya berlawanan dengan logika duniawi, tapi itulah **cara Allah menghitung**.",
  tldr: "Sedekah tidak mengurangi harta — Allah jamin dengan cara-Nya sendiri.",
  story: createQuoteStory("Harta Tidak Berkurang Karena Sedekah", "💎", [
    { hook: {
      title: "Takut sedekah bikin rugi?",
      body: "Kamu hitung-hitung pengeluaran, lalu tunda niat baik karena **takut gak cukup**. Padahal Rasulullah ﷺ sudah kasih jaminan yang menentang logika duniawi...",
    } },
    { source: {
      arabic: "مَا نَقَصَتْ صَدَقَةٌ مِنْ مَالٍ وَمَا زَادَ اللَّهُ عَبْدًا بِعَفْوٍ إِلَّا عِزًّا وَمَا تَوَاضَعَ أَحَدٌ لِلَّهِ إِلَّا رَفَعَهُ اللَّهُ",
      body: "**Sedekah itu tidak mengurangi harta.** Tidaklah seorang hamba memaafkan kecuali Allah menambah kemuliaannya. Dan tidaklah seseorang merendahkan diri karena Allah kecuali Allah mengangkat derajatnya.",
      title: "HR. Muslim no. 2588",
    } },
    { reveal: {
      body: "Sedekah bukan transaksi rugi. Ini **investasi yang Allah sendiri jamin**. Kamu mengeluarkan dengan tangan, tapi Allah mengembalikan dengan cara yang gak bisa kamu hitung — barakah, perlindungan, ketenangan hati.",
    } },
    { insight: {
      title: "Kenapa terasa rugi?",
      body: "Karena kita menghitung dengan kalkulator dunia: saldo berkurang, berarti rugi. Tapi Allah menghitung dengan **cara-Nya sendiri** — barakah di rezeki yang tersisa, perlindungan dari musibah, ketenangan yang uang gak bisa beli. Tiga jaminan dalam satu hadits: sedekah, memaafkan, tawadhu — semuanya **terasa mengurangi, tapi justru menambah**.",
    } },
    { engagement: {
      title: "Ingat terakhir kali kamu memberi dengan ikhlas?",
      body: "Ada ketenangan yang datang setelahnya — **itu bagian dari balasannya.** Yuk share hadits ini sebagai pengingat. 🤲",
    } },
  ]),
  related: ["sedekah-baqarah-261"],
};
